import { render } from "./Pd.vue?vue&type=template&id=451bba16"
import script from "./Pd.vue?vue&type=script&lang=js"
export * from "./Pd.vue?vue&type=script&lang=js"

import "./Pd.vue?vue&type=style&index=0&id=451bba16&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__